<template>
    <div class="token-animation" :style="tokenStyle" >
        <div class="token" ></div>
    </div>
</template>

<script>
import utils from '../../utils/utils.js';
export default {
    props: {
        tokenx: Number,
        tokeny: Number,
        tokenSize: Number,
        tokenScale: Number
    },
    data() {
        return {
            cur: 0
        }
    },
    computed: {
        scale() { return this.tokenScale || (this.tokenSize / 101) || 1 },
        tokenStyle() { return `left: ${this.tokenx}px;top: ${this.tokeny}px;transform: translate(-50%, -50%) scale(${this.scale});-webkit-transform: translate(-50%, -50%) scale(${this.scale});` }
    }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.token-animation {
    position: absolute;
    width: 120px;
    height: 120px;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);

    .token {
        height: 100%;
        background-image: url($assetRoot + "/choose_your_prize/desktop/token_animation.png");
        animation: token_animation step-end .3s infinite;
    }

    @-webkit-keyframes token_animation {
        0% { background-position: 0 0; }
        14% { background-position: -120px 0; }
        28% { background-position: -240px 0; }
        43% { background-position: -360px 0; }
        57% { background-position: -480px 0; }
        72% { background-position: -600px 0; }
        86% { background-position: -720px 0; }
    }

    @keyframes token_animation {
        0% { background-position: 0 0; }
        14% { background-position: -120px 0; }
        28% { background-position: -240px 0; }
        43% { background-position: -360px 0; }
        57% { background-position: -480px 0; }
        72% { background-position: -600px 0; }
        86% { background-position: -720px 0; }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/animations/RotateGoldenToken.vue